// extracted by mini-css-extract-plugin
export default {"wrapper":"customerInfo_wrapper__EWu4G"};